import { useEffect, useState } from "react"
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa6";
import axios from "axios"
import { Link, useNavigate } from "react-router-dom"
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const Register = () => {
    const navigate = useNavigate()
    const [email, setEmail] = useState("")
    const [otp, setOtp] = useState("")
    const [showOtp, setShowOtp] = useState(false)
    const [loading, setLoading] = useState(false)
    const [timeLeft, setTimeLeft] = useState(0)
    const { t } = useTranslation()

    // Function to start the timer and store timestamp
    const startTimer = () => {
        const now = Date.now()
        const expireTime = now + 60 * 1000 // 1-minute expiry
        localStorage.setItem("otp_timer", expireTime.toString())
        setTimeLeft(60)
    }

    // Effect to check the timer on mount
    useEffect(() => {
        const storedExpireTime = localStorage.getItem("otp_timer")
        if (storedExpireTime) {
            const remainingTime = Math.floor((parseInt(storedExpireTime) - Date.now()) / 1000)
            if (remainingTime > 0) {
                setTimeLeft(remainingTime)
            }
        }

        // Timer countdown
        const interval = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(interval)
                    localStorage.removeItem("otp_timer")
                    return 0
                }
                return prev - 1
            });
        }, 1000)

        return () => clearInterval(interval)
    }, [])

    const generateOtp = async () => {
        if (email.trim() === "") return toast.error(t('register.email_required'))
        setLoading(true)
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/generate-otp`, {
            email: email.trim(),
        }).then( res => {
            setLoading(false)
            console.log("res", res)
            // If user not exist, would be new user. So we will be also need to ask user to fill in all the info that we needed
            // show otp column
            setShowOtp(true)
            startTimer() // Start timer after OTP request
        }).catch( err => {
            setLoading(false)
            console.log("err", err)
            if (err.response.data && err.response.data.message) {
                toast.error(err.response.data.message)
            } else {
                toast.error(t("server_error"))
            }
        })
    };

    const checkExist = async () => {
        if (email.trim() === "" || otp.trim() === "") return toast.error(t('register.email_otp_required'))
        setLoading(true)
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/exist`, {
            "email": email.trim(),
            "otp": otp.trim()
        }, {headers: {'Content-Type': 'application/json', "Accept":"application/json"}, withCredentials: true }).then( res => {
            setLoading(false)
            console.log("res check exist", res)
            if (res.data.is_exist === false) {
                navigate(`/register-new?email=${email}`)
            } else {
                navigate(`/register-exist?email=${email}`)
            }
        }).catch( err => {
            setLoading(false)
            console.log("err", err.response)
            if (err.response) {
                // If the error has a response, check if it contains data and an error message
                if (err.response.data && err.response.data.error) {
                    toast.error(err.response.data.error)
                } else {
                    toast.error("An error occurred. Please try again.");
                }
            } else if (err.request) {
                // Request was made but no response was received (e.g., network issue)
                toast.error("No response from server. Please check your internet connection.");
            } else {
                // Other errors (e.g., code issues)
                toast.error("Something went wrong. Please try again.");
            }
        })
    }


    return (
        <div style={{ paddingTop: "2rem", paddingRight: "2rem", paddingLeft: "2rem", paddingBottom: "3rem", height: "100vh" }}>
            <div className="auth-page-header mb-3">
                <div className="container">
                    <img src={process.env.PUBLIC_URL + "/assets/img/koku.png"} className="img-fluid w-20" alt="" />
                    <h3 className="text-2xl self-center">{t('register.register_parent_account')}</h3>
                </div>
            </div>
            <div className="auth-page-body">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="px-2 py-4 rounded-3xl">
                                <form>
                                <div className="auth-form__single-field space-mb--30">
                                        <label>{t('register.email')}</label>
                                        <input value={email} disabled={showOtp} onChange={(e) => setEmail(e.target.value)} type="text" name="emailAddress" id="emailAddress" placeholder={t('register.enter_email_address')} />
                                    </div>
                                    {showOtp && (
                                    <div className="auth-form__single-field space-mb--30">
                                        <label>{t('register.otp')}</label>
                                        <input value={otp} onChange={(e) => setOtp(e.target.value)} type="text" placeholder={t('register.enter_otp')} />
                                    </div>
                                    )}
                                    <div className="auth-form__single-field mb-6">
                                        <p className="auth-form__info-text">
                                            {t('register.already_have_account')}{" "} <Link to={"/login"}>{t('register.sign_in_now')}</Link>
                                        </p>
                                    </div>

                                    <button type="button" className="text-white w-full py-[15px] bg-theme rounded-3xl flex items-center justify-center disabled:bg-gray-300" onClick={showOtp ? checkExist : generateOtp} disabled={(!showOtp && loading) || (!showOtp && timeLeft > 0)}>
                                        {loading ? (
                                            <FaSpinner className="animate-spin" />
                                        ) : (
                                            showOtp ? t('register.verify_otp') : timeLeft > 0 ? `Resend OTP (${timeLeft}s)` : t("register.send_otp")
                                        )}
                                    </button>

                                    <div className="row w-3/6 my-4 px-2 float-right">
                                    <select className="px-2 py-1 border rounded-full text-md bg-white focus:outline-none focus:ring-2 focus:ring-theme appearance-none" onChange={(e) => { i18next.changeLanguage(e.target.value) }} >
                                            <option value="-1" selected disabled>-- Language --</option>
                                            <option value="en">English</option>
                                            <option value="zh">Mandarin</option>
                                            <option value="ms">Bahasa</option>
                                        </select>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Register